import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import TestCaseList from './testCaseSection/TestCaseList'
import TestRunReport from './reportSection/TestRunReport'
import BasicDetails from './basicDetails/BasicDetails'
import ExportReportModal from './exportReport/ExportReportModal'
import TestRunTabs from '../../shared/TestRunTabs'
import { apiDownloadReport } from '../../../redux/testRun/testRun.service'
import {
    setFilter,
    setPagination,
    setSearchValue,
} from '../../../redux/testRun/testRunList.slice'
import styles from '../../../testrun.module.css'

const EMPTY_FILTER = {
    epic: [],
    sprint: '',
    tags: [],
    status: '',
}

const TestRunDetails = ({ reportId: reportIdProp, projectId }) => {
    const { id: routeId } = useParams()
    const id = reportIdProp || routeId
    const dispatch = useDispatch()

    const [exporting, setExporting] = useState(false)
    const [isOpen, setOpen] = useState(false)

    useEffect(() => {
        return () => {
            dispatch(setFilter(EMPTY_FILTER))
            dispatch(setSearchValue(''))
            dispatch(setPagination({ currentPage: 1, pageSize: 10 }))
        }
    }, [dispatch])

    const handleExportImage = async (payload) => {
        try {
            setExporting(true)

            const downloadReportResp = await apiDownloadReport(payload)

            const { data } = downloadReportResp
            if (data.status !== 200)
                throw new Error(`Download failed (${data.status})`)

            const link = document.createElement('a')
            link.href = URL.createObjectURL(data?.data)
            link.download = payload?.reportName?.replace(/\s+/g, '_')
            link.click()
            URL.revokeObjectURL(link.href)

            setOpen(false)
        } catch (err) {
            message.error(err.message || 'Failed to export report')
        } finally {
            setExporting(false)
        }
    }

    return (
        <div className={styles.pageContainer}>
            <TestRunTabs projectId={projectId} activeTab="reports" />
            <div className={styles.pageBlock}>
                <BasicDetails setOpen={setOpen} />
            </div>
            <div className={styles.pageBlock}>
                <TestRunReport reportId={id} />
            </div>
            <div className={styles.pageBlock}>
                <TestCaseList reportId={id} projectId={projectId} />
            </div>
            <ExportReportModal
                isOpen={isOpen}
                setOpen={setOpen}
                onExport={handleExportImage}
                exporting={exporting}
                reportId={id}
            />
        </div>
    )
}

export default TestRunDetails
